
import AppMissingModule from "@/components/common/MissingModule.vue";
import { AuthService } from "@/services/auth-service";
import Vue from "vue";
import CrmExtraFields from "@/models/crm/crm-extra-fields";
import { ExtraFieldNamesConfig } from "../../models/dossier-configs/extra-field-names-config";
import { DossierConfigService } from "../../services/dossier-config-service";
import AppExtraFieldsEdit from "../ExtraFieldsEdit.vue";
import { MODULE } from "@/config/modules";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => CrmExtraFields,
			required: true
		},
	},
	computed: {
		settings(): ExtraFieldNamesConfig {
			return DossierConfigService.getExtraFieldNamesConfigs().CrmNames;
		},
		isAllowed(): Boolean {
			return AuthService.hasModule(this.moduleId);
		},
		moduleId():number {
			return MODULE.EXTRA_VELDEN;
		}
	},
	methods: {
	},
	components: {
		AppExtraFieldsEdit,
		AppMissingModule
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	}
});
